import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";

import { StyledBorder } from "./bordered-block.styles";
import { BorderedBlockProps } from "./bordered-block.props";

export const BorderedBlock = withShowIf((props: BorderedBlockProps) =>
  props.bordersOff ? <>{props.children}</> : <StyledBorder>{props.children}</StyledBorder>
);
